import { DateTime } from 'luxon'

export function fromNow(timestamp) {
  try {
    return DateTime.fromMillis(parseInt(timestamp)).toRelative()
  } catch (e) {
    return ''
  }
}

export function formatDateTime(timestamp) {
  try {
    return DateTime.fromMillis(parseInt(timestamp)).toFormat('yyyy-MM-DD HH:mm')
  } catch (e) {
    return ''
  }
}
